import { ActFinishType } from '@/types/ActFinishType';
import { BaseApproveExecutor } from '../BaseApprove/BaseApproveExecutor';

export class ReworkExecutor extends BaseApproveExecutor {
    constructor() {
        super();

        this.approveModel = {
            commentIsRequired: true,
            actType: ActFinishType.Rework,
        };
    }
}
